import {Component, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {IYii} from '../../../globals';
import {FormService} from '../services/FormService';
import {Select} from 'primeng/select';
import {Button} from 'primeng/button';
import {InputGroup} from 'primeng/inputgroup';
import {FieldService} from '../services/FieldService';
import {SelectButton} from 'primeng/selectbutton';
import {FieldsContent} from './fields-content';
import {Splitter} from 'primeng/splitter';
import {NgFormsRenderModule, NgFormsRenderService} from '@betterchains/forms-render';
import {Subscription} from 'rxjs';

declare var Yii: IYii;

@Component({
  selector: 'ng-edit-fields-tab',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    Select,
    Button,
    InputGroup,
    SelectButton,
    FieldsContent,
    Splitter,
    NgFormsRenderModule
  ],
  templateUrl: './edit-fields-tab.html',
  styleUrls: ['./edit-fields-tab.scss'],
  providers: [
    NgFormsRenderService,
  ]
})
export class EditFieldsTabComponent implements OnInit, OnDestroy {
  Yii = Yii;

  private subs: Subscription[] = [];

  public previewOptions = [
    {value: 'fields', label: 'Fields'},
    {value: 'split', label: 'Split'},
    {value: 'form', label: 'Form'},
  ]

  public previewMode = 'fields'

  constructor(
    public fsvc: FormService,
    public fieldService: FieldService,
    private render: NgFormsRenderService
  ) {
    if (this.fieldService.AddField.types.length === 0 && this.fieldService.fields.length > 0) {
      this.fieldService.AddField.types = this.fieldService.fields;
    }
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  ngOnInit() {
    this.subs.push(
      this.fieldService.OnFieldChanged.subscribe({
        next: () => {
          this.syncPreview()
        }
      })
    )
    this.subs.push(
      this.fieldService.OnFieldAddOrRemoved.subscribe({
        next: () => {
          this.syncPreview()
        }
      })
    )
  }

  syncPreview() {
    const form = {...this.fsvc.form}
    form.form_json_content = JSON.stringify(this.fsvc.form)
    this.render.setForm(form)
  }
}
